import React from "react";
import styled from "styled-components";
import TableFields from "../../constants/FleetCoach/TableField.json";
import Table from "../Common/Table";
import { FlexContainer, Pill } from "../../constants/assets/containers";
import { useHistory } from "react-router-dom";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";
import Permission from "../Common/Permission";

const FleetCoachListView = (props) => {
  const history = useHistory();
  const { fleetCoachList } = props;
  const allActions = MenuActionsMappings[MenuNames.FLEET_COACH_V2];
  const getFieldValue = (activeObj, key, index) => {
    switch (key) {
      case "status": {
        return (
          <div className="flex items-center justify-center">
            <Pill isFalse={activeObj[key] === "INACTIVE"}>
              {activeObj[key]}
            </Pill>
          </div>
        );
      }
      case "action": {
        return (
          <Permission
            optionalPerms={[allActions.LIST, allActions.CREATE]}
            notAllowedText="No Actions Permitted"
          >
            <FlexContainer
              justify="flex-start"
              onClick={() => {
                history.push(`/v2/fleet-coach/${activeObj.id}`);
              }}
              className={"edit-options cursor-pointer actions-holder"}
              id={`actions_${index}`}
            >
              <span>View/Edit</span>
            </FlexContainer>
          </Permission>
        );
      }
      default: {
        return activeObj[key] ? activeObj[key] : "-";
      }
    }
  };
  return (
    <FleetCoachListContainer>
      <Table
        list={fleetCoachList}
        getFieldValue={getFieldValue}
        fields={TableFields}
      />
    </FleetCoachListContainer>
  );
};
const FleetCoachListContainer = styled.div`
  height: calc(100vh - 215px);
`;
export default FleetCoachListView;
